import { Checkbox } from "@/components/basics/Checkbox";
import { useRef, useEffect } from "react";

interface CheckboxHeaderProps {
  checked: boolean;
  onChange: () => void;
  ariaLabel: string;
  indeterminate?: boolean;
}

export function CheckboxHeader({ checked, onChange, ariaLabel, indeterminate = false }: CheckboxHeaderProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // The indeterminate state can only be set imperatively on the DOM element, not via a prop.
  useEffect(() => {
    if (inputRef.current) inputRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <th
      scope="col"
      className="px-3 py-2.5 text-start"
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex justify-center">
        <Checkbox
          ref={inputRef}
          checked={checked}
          onChange={onChange}
          ariaLabel={ariaLabel}
        />
      </div>
    </th>
  );
}
